import {
  Avatar,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import DetailCompetitorDialog from 'features/election/components/DetailCompetitorDialog';
import LabelCountElection from 'features/election/components/LabelCountElection';
import {ICompetitor} from 'features/election/store/types';
import React, {useEffect, useState} from 'react';

import {ISinglePlate, ISinglePlateCompetitor} from '../store/types';
interface IProps {
  election: ISinglePlate;
  clear: boolean;
  onChange: (plate: ISinglePlate) => void;
}
const SingleElectionItem: React.FC<IProps> = ({election, clear, onChange}) => {
  const [checkers, setCheckers] = useState<ICompetitor[]>(
    election.competitors.filter(comp => comp.checked)
  );

  useEffect(() => {
    if (clear) {
      setCheckers([]);
      election.competitors.map(comp => (comp.checked = false));
    }
  }, [clear]);

  const [
    currentCompetitor,
    setCurrentCompetitor,
  ] = useState<ICompetitor | null>(null);

  const [openDetailCompetitorDialog, setOpenDetailCompetitorDialog] = useState(
    false
  );

  const maxOptions: number =
    election && election.plate && election.plate.configs.choice_max
      ? election.plate.configs.choice_max
      : 0;

  const minOptions: number =
    election && election.plate && election.plate.configs.choice_min
      ? election.plate.configs.choice_min
      : 0;

  const handleToggle = (value: ISinglePlateCompetitor, index: number) => {
    value.checked = !value.checked;
    makeCheckers(value, index);
  };

  const makeCheckers = (
    value: ISinglePlateCompetitor,
    indexCompetitor: number
  ) => {
    const currentIndex = checkItemIndex(value);
    const newChecked = [...checkers];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const changedElention = {...election};
    changedElention.competitors[indexCompetitor] = value;
    changedElention.invalid =
      newChecked.length < minOptions ||
      (newChecked.length > maxOptions && maxOptions !== 0);

    onChange(changedElention);

    setCheckers(newChecked);
  };

  const checkItemIndex = (item: ICompetitor) => {
    return checkers.findIndex((p: ICompetitor) => p.id === item.id);
  };

  const showDetailCompetitor = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    competitor: ICompetitor
  ) => {
    event.stopPropagation();
    setCurrentCompetitor(competitor);
    setOpenDetailCompetitorDialog(true);
  };

  if (!election || !election.plate) {
    return null;
  }

  return (
    <div className="election mb-24 mb-15 election-single-item">
      <div className="full-width secondary-toolbar">
        <h3 className="mt-0">
          <strong>{election.plate.name}</strong>
        </h3>
      </div>

      {/* checkers */}
      <div className=" full-width">
        <LabelCountElection
          min={minOptions}
          max={maxOptions}
          count={checkers.length}
          fixed={false}
        />

        {election.competitors && (
          <List component="nav" className="list-white" aria-label="eleições">
            {election.competitors.map((value, index) => {
              const labelId = `checkbox-list-label-${value.id}`;

              return (
                <ListItem
                  key={value.id}
                  role={undefined}
                  dense={true}
                  button={true}
                  onClick={() => handleToggle(value, index)}
                  className={value.checked ? 'selected ' : ''}
                >
                  <Checkbox
                    edge="start"
                    checked={value.checked}
                    tabIndex={-1}
                    disableRipple={true}
                    inputProps={{'aria-labelledby': labelId}}
                  />
                  <ListItemText id={labelId} primary={value.name} />
                  <div onClick={event => showDetailCompetitor(event, value)}>
                    <ListItemAvatar>
                      <Avatar
                        sizes="large"
                        alt={value.name}
                        src={value.thumb}
                      />
                    </ListItemAvatar>
                  </div>
                </ListItem>
              );
            })}
          </List>
        )}
      </div>

      {currentCompetitor && (
        <DetailCompetitorDialog
          open={openDetailCompetitorDialog}
          competitor={currentCompetitor}
          onClose={() => setOpenDetailCompetitorDialog(false)}
        />
      )}
    </div>
  );
};

export default SingleElectionItem;



// WEBPACK FOOTER //
// ./src/features/election-single/components/SingleElectionItem.tsx